function lerp(min, max, ratio) {
  return (1 - ratio) * min + ratio * max;
}
export {
  lerp as default
};
//# sourceMappingURL=lerp.js.map
